import { EmptyState, IconTechServiceInternetRegular, skinVars } from '@telefonica/mistica';
import { useTranslation } from 'react-i18next';
import './index.scss';

export const Stopper: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className='stopper'>
            <EmptyState
                icon={<IconTechServiceInternetRegular color={skinVars.colors.brand} size={53} />}
                title={t('serviceNotAvaiable')}
                description={t('stopperDescription')}
            ></EmptyState>
        </div>
    );
};

export default Stopper;
